import styled from 'styled-components';
import NativeLink from '../../common/NativeLink';

const ModalContentWrapper = styled.div`
  background: #fff;
  padding: 25px;
  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding: 40px 80px;
  }
`;

const Title = styled.div`
  font-family: ${(props) => props.theme.font.family};
  font-style: normal;
  font-weight: ${(props) => props.theme.font.weight.v300};
  ${(props) => props.theme.font.heading.v300};
  line-height: 24px;
  padding-bottom: 25px;
  text-transform: uppercase;
  text-align: center;
`;

const MainHeader = styled.div`
  font-family: ${(props) => props.theme.font.family};
  font-style: normal;
  font-weight: ${(props) => props.theme.font.weight.v300};
  font-size: 20px;
  line-height: 24px;
  padding: 15px 0 25px;
  color: ${(props) => props.theme.color.primary.v600};
  text-transform: uppercase;
`;

const SubHeader = styled.div`
  ${(props) => props.theme.font.heading.v100};
  text-transform: uppercase;
  color: ${(props) => props.theme.color.primary.v600};
`;

const Paragraph = styled.p`
  font-family: ${(props) => props.theme.font.family};
  font-style: normal;
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.label.v400};
  line-height: 28px;
  padding-bottom: 25px;
  margin: 0;
  color: ${(props) => props.theme.color.neutral.v500};
`;

const HyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
`;

export {
  ModalContentWrapper,
  Title,
  MainHeader,
  SubHeader,
  Paragraph,
  HyperLink,
};
